/* src/app/shared/common-ui/lib/button/button.component.less */
:host {
  display: inline-flex;
}
:host .wrapper {
  flex: 1;
  display: flex;
}
:host .wrapper button {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.6rem 1.8rem;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.5rem;
  letter-spacing: 0.1rem;
  border: initial;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
:host .wrapper button.end {
  flex-direction: row-reverse;
}
:host .wrapper button.regular {
  min-height: 3.6rem;
  min-width: 12rem;
  text-transform: uppercase;
  color: var(--color-default-button);
  background: transparent;
  border: 0.2rem solid var(--color-default-button);
}
:host .wrapper button.regular .icon {
  background: var(--color-default-button);
}
:host .wrapper button.regular.alternative {
  color: var(--color-alternative-button);
  border: 0.2rem solid var(--color-alternative-button-text);
}
:host .wrapper button.regular.alternative .icon {
  background: var(--color-alternative-button);
}
:host .wrapper button.regular:hover {
  color: var(--color-default-button-hover);
  border: 0.2rem solid var(--color-default-button-hover);
}
:host .wrapper button.regular:hover .icon {
  background: var(--color-default-button-hover);
}
:host .wrapper button.regular:active {
  color: var(--color-default-button-active);
  border: 0.2rem solid var(--color-default-button-active);
}
:host .wrapper button.regular:active .icon {
  background: var(--color-default-button-active);
}
:host .wrapper button.regular:disabled {
  color: var(--color-default-button-disabled);
  border: 0.2rem solid var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
}
:host .wrapper button.regular:disabled .icon {
  background: var(--color-default-button-disabled);
}
:host .wrapper button.regular.attractive {
  color: var(--color-default-button-text);
  background: var(--color-default-button);
  border: 0.2rem solid var(--color-default-button);
}
:host .wrapper button.regular.attractive .icon {
  background: var(--color-default-button-text);
}
:host .wrapper button.regular.attractive.alternative {
  color: var(--color-default-button);
  background: var(--color-alternative-button);
  border: 0.2rem solid var(--color-alternative-button);
}
:host .wrapper button.regular.attractive.alternative .icon {
  background: var(--color-default-button);
}
:host .wrapper button.regular.attractive:hover:not([disabled]) {
  background: var(--color-default-button-hover);
  border: 0.2rem solid var(--color-default-button-hover);
}
:host .wrapper button.regular.attractive:hover:not([disabled]) .icon {
  background: var(--color-default-button-text);
}
:host .wrapper button.regular.attractive:hover:not([disabled]).alternative {
  color: var(--color-default-button-hover);
  background: var(--color-alternative-button);
  border: 0.2rem solid var(--color-alternative-button);
}
:host .wrapper button.regular.attractive:hover:not([disabled]).alternative .icon {
  background: var(--color-default-button-hover);
}
:host .wrapper button.regular.attractive:active,
:host .wrapper button.regular.attractive:hover:active {
  background: var(--color-default-button-active);
  border: 0.2rem solid var(--color-default-button-active);
}
:host .wrapper button.regular.attractive:active .icon,
:host .wrapper button.regular.attractive:hover:active .icon {
  background: var(--color-default-button-text);
}
:host .wrapper button.regular.attractive:active.alternative,
:host .wrapper button.regular.attractive:hover:active.alternative {
  color: var(--color-alternative-button-active);
  background: var(--color-alternative-button);
  border: 0.2rem solid var(--color-alternative-button);
}
:host .wrapper button.regular.attractive:active.alternative .icon,
:host .wrapper button.regular.attractive:hover:active.alternative .icon {
  background: var(--color-alternative-button-active);
}
:host .wrapper button.regular.attractive:disabled {
  color: var(--color-default-button-text-disabled);
  background: var(--color-default-button-disabled);
  border: 0.2rem solid var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
}
:host .wrapper button.regular.attractive:disabled .icon {
  background: var(--color-default-button-text-disabled);
}
:host .wrapper button.regular.attractive.heavy {
  background: var(--color-default-button-heavy);
  border: 0.2rem solid var(--color-default-button-heavy);
}
:host .wrapper button.regular.attractive.heavy .icon {
  background: var(--color-default-button-heavy-text);
}
:host .wrapper button.regular.attractive.heavy.alternative {
  color: var(--color-default-button-heavy-text);
}
:host .wrapper button.regular.attractive.heavy.alternative .icon {
  background: var(--color-default-button-heavy-text);
}
:host .wrapper button.regular.attractive.heavy:hover:not([disabled]) {
  background: var(--color-default-button-heavy-hover);
  border: 0.2rem solid var(--color-default-button-heavy-hover);
}
:host .wrapper button.regular.attractive.heavy:hover:not([disabled]) .icon {
  background: var(--color-default-button-heavy-text);
}
:host .wrapper button.regular.attractive.heavy:hover:not([disabled]).alternative {
  color: var(--color-alternative-button-heavy-text-hover);
  border: 0.2rem solid var(--color-default-button-heavy-hover);
}
:host .wrapper button.regular.attractive.heavy:hover:not([disabled]).alternative .icon {
  background: var(--color-default-button-heavy-text);
}
:host .wrapper button.regular.attractive.heavy:active,
:host .wrapper button.regular.attractive.heavy:hover:active {
  background: var(--color-default-button-heavy-active);
  border: 0.2rem solid var(--color-default-button-heavy-active);
}
:host .wrapper button.regular.attractive.heavy:active .icon,
:host .wrapper button.regular.attractive.heavy:hover:active .icon {
  background: var(--color-default-button-heavy-text);
}
:host .wrapper button.regular.attractive.heavy:active.alternative,
:host .wrapper button.regular.attractive.heavy:hover:active.alternative {
  color: var(--color-alternative-button-heavy-text-active);
  border: 0.2rem solid var(--color-default-button-heavy-active);
}
:host .wrapper button.regular.attractive.heavy:active.alternative .icon,
:host .wrapper button.regular.attractive.heavy:hover:active.alternative .icon {
  background: var(--color-default-button-heavy-text);
}
:host .wrapper button.regular.attractive.heavy:disabled {
  color: var(--color-default-button-text-disabled);
  background: var(--color-default-button-disabled);
  border: 0.2rem solid var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
}
:host .wrapper button.regular.attractive.heavy:disabled .icon {
  background: var(--color-default-button-text-disabled);
}
:host .wrapper button.flat {
  display: flex;
  align-items: center;
  min-width: inherit;
  padding: initial;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5rem;
  letter-spacing: 0.135rem;
  text-transform: uppercase;
  color: var(--color-default-button-text-even);
  background: transparent;
  border: initial;
  opacity: initial;
}
:host .wrapper button.flat .icon {
  background: var(--color-default-button-text-even);
}
:host .wrapper button.flat.alternative {
  color: var(--color-default-button-text);
}
:host .wrapper button.flat.alternative .icon {
  background: var(--color-default-button-text);
}
:host .wrapper button.flat:hover:not([disabled]) {
  opacity: 0.75;
}
:host .wrapper button.flat:hover:not([disabled]).alternative {
  color: var(--color-default-button-hover);
  opacity: initial;
}
:host .wrapper button.flat:hover:not([disabled]).alternative .icon {
  background: var(--color-default-button-hover);
}
:host .wrapper button.flat:active,
:host .wrapper button.flat:hover:active {
  color: var(--color-default-text);
  opacity: initial;
}
:host .wrapper button.flat:active .icon,
:host .wrapper button.flat:hover:active .icon {
  background: var(--color-default-text);
}
:host .wrapper button.flat:active.alternative,
:host .wrapper button.flat:hover:active.alternative {
  color: var(--color-default-button-active);
  opacity: initial;
}
:host .wrapper button.flat:active.alternative .icon,
:host .wrapper button.flat:hover:active.alternative .icon {
  background: var(--color-default-button-active);
}
:host .wrapper button.flat.attractive {
  color: var(--color-default-button);
  opacity: initial;
}
:host .wrapper button.flat.attractive .icon {
  background: var(--color-default-button);
}
:host .wrapper button.flat.attractive.alternative {
  color: var(--color-alternative-button-text);
}
:host .wrapper button.flat.attractive.alternative .icon {
  background: var(--color-alternative-button-text);
}
:host .wrapper button.flat.attractive:hover:not([disabled]) {
  color: var(--color-default-button-hover);
  opacity: initial;
}
:host .wrapper button.flat.attractive:hover:not([disabled]) .icon {
  background: var(--color-default-button-hover);
}
:host .wrapper button.flat.attractive:hover:not([disabled]).alternative {
  color: var(--color-alternative-button-hover);
}
:host .wrapper button.flat.attractive:hover:not([disabled]).alternative .icon {
  background: var(--color-alternative-button-hover);
}
:host .wrapper button.flat.attractive:active,
:host .wrapper button.flat.attractive:hover:active {
  color: var(--color-default-button-active);
}
:host .wrapper button.flat.attractive:active .icon,
:host .wrapper button.flat.attractive:hover:active .icon {
  background: var(--color-default-button-active);
}
:host .wrapper button.flat.attractive:active.alternative,
:host .wrapper button.flat.attractive:hover:active.alternative {
  color: var(--color-alternative-button-active);
}
:host .wrapper button.flat.attractive:active.alternative .icon,
:host .wrapper button.flat.attractive:hover:active.alternative .icon {
  background: var(--color-alternative-button-active);
}
:host .wrapper button.flat.attractive.heavy {
  color: var(--color-default-button-heavy);
}
:host .wrapper button.flat.attractive.heavy .icon {
  background: var(--color-default-button-heavy);
}
:host .wrapper button.flat.attractive.heavy.alternative {
  color: var(--color-default-button-text);
}
:host .wrapper button.flat.attractive.heavy.alternative .icon {
  background: var(--color-default-button-text);
}
:host .wrapper button.flat.attractive.heavy:disabled {
  color: var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
}
:host .wrapper button.flat.attractive.heavy:disabled .icon {
  background: var(--color-default-button-disabled);
}
:host .wrapper button.flat.attractive.heavy:hover:not([disabled]) {
  color: var(--color-default-button-heavy-hover);
}
:host .wrapper button.flat.attractive.heavy:hover:not([disabled]) .icon {
  background: var(--color-default-button-heavy-hover);
}
:host .wrapper button.flat.attractive.heavy:hover:not([disabled]).alternative {
  color: var(--color-alternative-button-hover);
}
:host .wrapper button.flat.attractive.heavy:hover:not([disabled]).alternative .icon {
  background: var(--color-alternative-button-hover);
}
:host .wrapper button.flat.attractive.heavy:active,
:host .wrapper button.flat.attractive.heavy:hover:active {
  color: var(--color-default-button-heavy-active);
}
:host .wrapper button.flat.attractive.heavy:active .icon,
:host .wrapper button.flat.attractive.heavy:hover:active .icon {
  background: var(--color-default-button-heavy-active);
}
:host .wrapper button.flat.attractive.heavy:active.alternative,
:host .wrapper button.flat.attractive.heavy:hover:active.alternative {
  color: var(--color-alternative-button-active);
}
:host .wrapper button.flat.attractive.heavy:active.alternative .icon,
:host .wrapper button.flat.attractive.heavy:hover:active.alternative .icon {
  background: var(--color-alternative-button-active);
}
:host .wrapper button.flat.attractive:disabled {
  color: var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
}
:host .wrapper button.flat.attractive:disabled .icon {
  background: var(--color-default-button-disabled);
}
:host .wrapper button.flat:disabled {
  color: var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
}
:host .wrapper button.flat:disabled .icon {
  background: var(--color-default-button-disabled);
}
:host .wrapper button.link {
  padding: initial;
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: inherit;
  text-transform: inherit;
  color: var(--color-default-button);
  background: transparent;
  text-decoration: underline;
}
:host .wrapper button.link.hasIcon {
  text-decoration: initial;
}
:host .wrapper button.link .icon {
  background: var(--color-default-button);
}
:host .wrapper button.link.alternative {
  color: var(--color-default-button-text);
}
:host .wrapper button.link.alternative .icon {
  background: var(--color-default-button-text);
}
:host .wrapper button.link:hover:not([disabled]) {
  color: var(--color-default-button-hover);
}
:host .wrapper button.link:hover:not([disabled]) .icon {
  background: var(--color-default-button-hover);
}
:host .wrapper button.link:hover:not([disabled]).alternative {
  color: var(--color-default-button-hover);
}
:host .wrapper button.link:hover:not([disabled]).alternative .icon {
  background: var(--color-default-button-hover);
}
:host .wrapper button.link:active,
:host .wrapper button.link:hover:active {
  color: var(--color-default-button-active);
  opacity: initial;
}
:host .wrapper button.link:active .icon,
:host .wrapper button.link:hover:active .icon {
  background: var(--color-default-button-active);
}
:host .wrapper button.link:active.alternative,
:host .wrapper button.link:hover:active.alternative {
  color: var(--color-default-button-active);
  opacity: initial;
}
:host .wrapper button.link:active.alternative .icon,
:host .wrapper button.link:hover:active.alternative .icon {
  background: var(--color-default-button-active);
}
:host .wrapper button.link:disabled {
  color: var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
  text-decoration: initial;
}
:host .wrapper button.link:disabled .icon {
  background: var(--color-default-button-disabled);
}
:host .wrapper .icon {
  height: 1.8rem;
  width: 1.8rem;
}
:host .wrapper .icon.start {
  margin-right: 0.5rem;
}
:host .wrapper .icon.start.noContent {
  margin-right: initial;
}
:host .wrapper .icon.end {
  margin-left: 0.5rem;
}
:host .wrapper .icon.end.noContent {
  margin-left: initial;
}
:host .wrapper .icon.add {
  mask: url("./media/icon-button-add.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.addComment {
  mask: url("./media/icon-button-add-comment.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.edit {
  mask: url("./media/icon-button-edit.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.view {
  mask: url("./media/icon-button-view.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.hide {
  mask: url("./media/icon-action-menu-hide.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.save {
  mask: url("./media/icon-button-save.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.delete {
  background: var(--color-state-error);
  mask: url("./media/icon-button-delete.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.upload {
  mask: url("./media/icon-button-upload.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.download {
  mask: url("./media/icon-button-download.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.library {
  mask: url("./media/icon-button-library.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.filterInActive {
  mask: url("./media/icon-button-filter-inactive.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.filterActive {
  mask: url("./media/icon-button-filter-active.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.search {
  mask: url("./media/icon-button-search.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.bookmarkInActive {
  mask: url("./media/icon-button-bookmark-inactive.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.bookmarkActive {
  mask: url("./media/icon-button-bookmark-active.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.debug {
  mask: url("./media/icon-button-debug.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.message {
  mask: url("./media/icon-button-message.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.previous {
  mask: url("./media/icon-button-previous.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.next {
  mask: url("./media/icon-button-next.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.fullscreenEnter {
  mask: url("./media/icon-fullscreen-enter.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.fullscreenExit {
  mask: url("./media/icon-fullscreen-exit.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.history {
  mask: url("./media/icon-button-history.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.more {
  mask: url("./media/icon-button-more.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.collapse {
  mask: url("./media/icon-button-collapse.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.expand {
  mask: url("./media/icon-button-expand.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.expandAll {
  mask: url("./media/icon-button-expand-all.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.collapseAll {
  mask: url("./media/icon-button-collapse-all.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.link {
  mask: url("./media/icon-button-link.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.duplicate {
  mask: url("./media/icon-button-duplicate.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.externalLink {
  mask: url("./media/icon-button-external-link.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.setAsDefault {
  background: var(--color-accent-1);
  mask: url("./media/icon-button-set-as-default.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.indent {
  mask: url("./media/icon-indent.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.outdent {
  mask: url("./media/icon-outdent.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.undo {
  mask: url("./media/icon-undo.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.redo {
  mask: url("./media/icon-redo.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.orderedList {
  mask: url("./media/icon-ordered-list.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.quiz {
  mask: url("./media/icon-quiz.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.unorderedList {
  mask: url("./media/icon-unordered-list.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.reject {
  background: var(--color-state-error);
  mask: url("./media/icon-button-reject.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.switch {
  mask: url("./media/icon-button-switch.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.zoomReset {
  mask: url("./media/icon-button-zoom-reset.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.reset {
  mask: url("./media/icon-button-reset.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.modules {
  mask: url("./media/icon-button-modules.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.modulesAdd {
  mask: url("./media/icon-button-modulesAdd.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.scan {
  mask: url("./media/icon-button-scan.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper .icon.share {
  mask: url("./media/icon-button-share.svg") no-repeat center;
  mask-size: 1.8rem 1.8rem;
}
/*# sourceMappingURL=button.component.css.map */
